import React, { useState } from 'react'
import '../profile.scss'

const Trees = ({ treesArray, onTreeRenamed }) => {
  const [editingTreeId, setEditingTreeId] = useState(null);
  const [newName, setNewName] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRenameClick = (tree) => {
    setEditingTreeId(tree.treeId);
    setNewName(tree.treeName || '');
    setShowModal(true);
    setError('');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingTreeId(null);
    setNewName('');
    setError('');
  };

  const handleSaveName = async () => {
    if (!newName.trim()) {
      setError('Please enter a name for the tree');
      return;
    }

    if (newName.length > 255) {
      setError('Tree name is too long (max 255 characters)');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const apiKey = '0a032477a6f2cc1cd91960d1e554561151f0458ca433e98b848d';
      const response = await fetch('https://app.nftforest.ge/profile/rename_tree/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiKey}`,
          'User-Agent': 'EricLystra',
          'x-auth': 'NFTForest',
          'x-api-key': apiKey,
        },
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify({
          tree_id: editingTreeId,
          name: newName.trim()
        })
      });

      const result = await response.json();

      if (result.success) {
        handleCloseModal();
        // Notify parent component to refresh tree list
        if (onTreeRenamed) {
          onTreeRenamed();
        }
      } else {
        setError(result.error || 'Failed to rename tree');
      }
    } catch (err) {
      setError('Network error. Please try again.');
      console.error('Error renaming tree:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSaveName();
    } else if (e.key === 'Escape') {
      handleCloseModal();
    }
  };

  // Debug: Log trees array
  console.log('Trees component - treesArray:', treesArray);

  return (
    <div className='trees' style={{ width: '100%', padding: '1rem' }}>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {treesArray && treesArray.length > 0 ? (
          treesArray.map((tree) => {
            console.log('Rendering tree:', tree);
            return (
              <li 
                key={tree.treeId || tree.id}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '1rem 1.25rem',
                  marginBottom: '0.75rem',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0',
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                }}
              >
                <span style={{ flex: 1, color: '#333', fontSize: '1.1rem', fontWeight: '500' }}>
                  {tree.treeName && tree.treeName.trim() ? (
                    tree.treeName
                  ) : (
                    <>Tree</>
                  )}
                </span>
                <button 
                  className="rename-tree-btn" 
                  onClick={() => handleRenameClick(tree)}
                  title="Rename tree"
                  style={{
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: '2px solid #4CAF50',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                    marginLeft: '1rem',
                    whiteSpace: 'nowrap',
                    minWidth: '120px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                    display: 'inline-block',
                    visibility: 'visible',
                    opacity: 1
                  }}
                >
                  ✏️ Rename Tree
                </button>
              </li>
            );
          })
        ) : (
          <li>No trees found</li>
        )}
      </ul>

      {/* Rename Modal */}
      {showModal && (
        <div className="rename-modal-overlay" onClick={handleCloseModal}>
          <div className="rename-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="rename-modal-header">
              <h3>Rename Tree</h3>
              <button className="close-btn" onClick={handleCloseModal}>×</button>
            </div>
            <div className="rename-modal-body">
              <p>Please give name to tree as you want</p>
              <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                onKeyDown={handleKeyPress}
                placeholder="Enter tree name..."
                maxLength={255}
                autoFocus
                disabled={loading}
              />
              {error && <div className="error-message">{error}</div>}
            </div>
            <div className="rename-modal-footer">
              <button 
                className="cancel-btn" 
                onClick={handleCloseModal}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                className="save-btn" 
                onClick={handleSaveName}
                disabled={loading || !newName.trim()}
              >
                {loading ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Trees